import apiInstance from "./apiInstance";

const getSiteSettings = () => {
  return apiInstance.get("site-settings");
};

const getSiteSettingByType = (type) => {
  return apiInstance.get(`site-settings/sha1/${type}`);
};

const updateSiteSettings = (settings) => {
  return apiInstance.post("site-settings", settings);
};

const getExtraSetting = (key) => {
  return apiInstance.get(`site-settings/extra-settings/${key}`);
};

export { getSiteSettings, getSiteSettingByType, updateSiteSettings, getExtraSetting };
